<template>
  <div>
    <el-drawer
      class="tips-drawer"
      title="高光快投"
      :size="450"
      :visible.sync="showAutoLaunch"
      :modal="false"
      :before-close="handleClose"
    >
      <div class="content">
        <p class="content-title">开启</p>
        <p class="content-paragraph">
          开启高光快投后，您可通过该功能对您推广的直播内容进行智能剪辑，形成高光片段后作为创意素材进行投放，请确保直播内容的剪辑和投放已获合法授权。高光快投功能的投放效果可以在“计划详情-创意”中查看。
        </p>
        <p class="content-paragraph">
          请务必知悉，开启本功能将锁定本次推广计划的部分预算，包括锁定用于开启本功能的预算最低金额和后续预算调整（下调）幅度。您后续进行预算调整时，无法调整被锁定的预算部分，将导致下调预算失败，请谨慎操作并合理安排。
        </p>
        <el-image
          class="img"
          src="https://p3-ecom.byteimg.com/tos-cn-i-55ejei7tpt/0c89bbc2b60551b69e0a45c0b117b7c7.gif~tplv-55ejei7tpt-image.image"
          fit="cover"
        ></el-image>
        <p class="content-title">关闭</p>
        <p class="content-paragraph">
          关闭高光创意功能后，系统将仅根据您选择的创意进行投放。
        </p>
        <p class="content-paragraph">
          您知悉并同意，如在开启本功能后再关闭本功能，原定用于开启本功能的剩余预算将无法实时同步至当天的预算数据展示中。
        </p>
      </div>

      <div class="user-feedback">
        <p>对你是否有帮助？</p>
        <div class="btns">
          <div class="btn"><i class="el-icon-success"></i> 有帮助</div>
          <div class="btn"><i class="el-icon-error"></i> 没帮助</div>
        </div>
      </div>
    </el-drawer>

    <el-drawer
      class="tips-drawer"
      title="创意类型"
      :size="450"
      :visible.sync="showCreativeType"
      :modal="false"
      :before-close="handleClose"
    >
      <div class="content">
        <p class="content-title">程序化创意</p>
        <p class="content-paragraph">
          根据上传的素材、标题、推广卡片自动生成不同的组合。节省制作更多创意的时间，快速尝试寻找更优质的创意组合。
        </p>
        <el-image
          class="img"
          src="https://p3-ecom.byteimg.com/tos-cn-i-55ejei7tpt/f31c35a5ef03409eaa4c0b1ec037ae49.gif~tplv-55ejei7tpt-image.image"
          fit="cover"
        ></el-image>
        <p class="content-title">自定义创意</p>
        <p class="content-paragraph">
          由自主选择的素材、标题、推广卡片组成一个特定的组合。在明确创意质量和定向人群的情况下，更有目标的投放广告。
        </p>
        <el-image
          class="img"
          src="https://p3-ecom.byteimg.com/tos-cn-i-55ejei7tpt/9818f76297e08204c35777b7788c75c3.jpg~tplv-55ejei7tpt-image.image"
          fit="cover"
        ></el-image>
      </div>

      <div class="user-feedback">
        <p>对你是否有帮助？</p>
        <div class="btns">
          <div class="btn"><i class="el-icon-success"></i> 有帮助</div>
          <div class="btn"><i class="el-icon-error"></i> 没帮助</div>
        </div>
      </div>
    </el-drawer>

    <el-drawer
      class="tips-drawer"
      title="什么是计划托管？"
      :size="450"
      :visible.sync="showPlanHosting"
      :modal="false"
      :before-close="handleClose"
    >
      <div class="content">
        <p class="content-paragraph">
          投放中，系统会更好地帮你管理计划，如合理调整出价、快速复制计划等。系统将智能帮助<span
            >优质素材</span
          ><el-popover placement="top" trigger="hover">
            <p style="font-size: 12px">泛指跑量或转化效果较好的素材</p>
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
          持续跑量，并尝试打爆<span>潜力素材</span
          ><el-popover placement="top" trigger="hover" width="200">
            <p style="font-size: 12px; line-height: 2">
              泛指有一定消耗和转化且消耗和转化呈明显上升趋势，投入更多预算有很大机会打爆的素材
            </p>
            <i class="el-icon-question" slot="reference"></i> </el-popover
          >。整个过程你无需费心，由系统智能执行
        </p>
        <el-image
          class="img"
          src="https://p3-ecom.byteimg.com/tos-cn-i-55ejei7tpt/7dd55f76393bb1a39113146e1a668e03.gif~tplv-55ejei7tpt-image.image"
          fit="cover"
        ></el-image>
      </div>

      <div class="user-feedback">
        <p>对你是否有帮助？</p>
        <div class="btns">
          <div class="btn"><i class="el-icon-success"></i> 有帮助</div>
          <div class="btn"><i class="el-icon-error"></i> 没帮助</div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  props: {
    showAutoLaunch: Boolean,
    showCreativeType: Boolean,
    showPlanHosting: Boolean,
  },
  methods: {
    handleClose() {
      this.$emit("onClose");
    },
  },
};
</script>

<style lang="less" scoped>
.el-icon-question {
  color: #d3d3d3;
  font-size: 16px;
  vertical-align: -1px;
  cursor: pointer;
}
::v-deep .tips-drawer {
  .el-drawer__header {
    margin-bottom: 0;
    color: #333;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
  }
  .content {
    padding: 0 24px;
    .content-title {
      font-size: 14px;
      color: #333;
      margin-top: 24px;
      font-weight: 600;
    }
    .content-paragraph {
      font-size: 14px;
      color: #333;
      line-height: 22px;
      text-align: justify;
      margin-top: 8px;
    }
    .img {
      margin-top: 16px;
      width: 328px;
      height: 184px;
      border-radius: 8px;
    }
  }
  .user-feedback {
    display: flex;
    justify-content: space-between;
    padding: 0 24px;
    margin-top: 32px;
    font-size: 14px;
    line-height: 22px;
    color: #666;
  }
  .btn {
    display: inline-block;
    margin-left: 15px;
    padding: 3px 16px;
    min-width: 88px;
    height: 26px;
    color: #666;
    font-size: 12px;
    text-align: center;
    user-select: none;
    background-color: #f2f2f2;
    border-radius: 4px;
    cursor: pointer;
    &:hover {
      background-color: #edf1fd;
    }
  }
}
</style>